import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, ProgressBar, Stack } from "react-bootstrap";

import { useForm, useMutation } from "../../hooks";
import TextInput from "../Input/TextInput";
import StatusMessage from "./StatusMessage";

type LoginResponse = {
  token?: string;
};

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const hash = location.hash;

  const { form, registerField, validateForm } = useForm({ email: "" });
  const { values } = form;
  const loginMutation = useMutation("users/login");

  useEffect(() => {
    if (hash && !loginMutation.isPending) {
      loginMutation.mutate(
        { login_token: hash.slice(1) },
        {
          onSuccess: handleSubmitSuccess,
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  const mutation = useMutation("users/request_login");
  const { data, error } = mutation;

  const handleSubmitSuccess = (data: LoginResponse) => {
    if (data?.token) {
      localStorage.setItem("token", data.token);
      navigate("/");
    }
  };

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!validateForm()) return false;
    mutation.mutate(values);
  }

  function renderMutationResponse() {
    if (error?.message) {
      return <StatusMessage error message={error.message} />;
    }
    if (data?.success) return <StatusMessage message={data.success} />;
    return null;
  }

  if (hash && loginMutation.error?.message) {
    return (
      <Stack className="col-md-4 mx-auto">
        <StatusMessage error message="There was an error logging you in." />
        <Link className="button" to="/login">
          Request a new login link
        </Link>
      </Stack>
    );
  }

  if (hash) {
    return (
      <Stack className="col-md-4 mx-auto">
        <ProgressBar animated now={100} />
        <p>Logging In</p>
      </Stack>
    );
  }

  return (
    <Stack className="col-md-5 mx-auto">
      <h2>Login</h2>
      <Form noValidate onSubmit={handleSubmit}>
        <TextInput label="Email" {...registerField("email", { email: true })} />
        {renderMutationResponse()}
        <div className="d-flex flex-column align-items-center">
          <button className="button" type="submit">
            Request Login Link
          </button>
        </div>
      </Form>
    </Stack>
  );
}
